// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blocking-event-free-busy{z-index:3 !important}.free-busy-block{opacity:.7 !important}`, "",{"version":3,"sources":["webpack://./src/components/Editor/FreeBusy/FreeBusy.vue"],"names":[],"mappings":"AACA,0BAEC,oBAAA,CAGD,iBACC,qBAAA","sourcesContent":[".blocking-event-free-busy{z-index:3 !important}.free-busy-block{opacity:.7 !important}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
